import React from 'react';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MembershipsCards from '../MembershipsCards/index';

const iconBlue = '/img/icons/calendar-blue.svg';
const iconGray = '/img/icons/calendar-gray.svg';

const TabInversion = props => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={5} padding="48px 0 0" maxWidth="980px">
        {children}
      </Box>
    </Typography>
  );
};

TabInversion.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    height: 88,
    maxWidth: 520,
    borderRadius: 4,
    margin: 'auto',
  },
  root: {
    flexGrow: 1,
    backgroundColor: '#f6f8fb',
    maxWidth: 980,
    margin: 'auto',
    marginBottom: 20,
  },
  tabStyle: {
    width: '50%',
    //maxWidth: 232,
    //minWidth: '20%',
    height: 66,
    //padding: '0 32px',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    '&$selected': {
      color: '#013957',
    },
    '@media screen and (max-width: 549px)': {
      minWidth: '100%',
    },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  tabs: {
    padding: '0 24px',
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    //width: 'fit-content',
    margin: 'auto',
  },
  scrollButtonsDesktop: {
    color: '#013957',
    display: 'none',
    '@media (max-width: 890px)': {
      display: 'inherit',
    },
    '&>svg': {
      fontSize: 24,
    },
  },
  panel: {
    position: 'relative',
    maxWidth: 980,
  },
  tabWrapper: {
    display: 'contents',
  },
}));

export default function ScrollableTabsButtonAuto() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          classes={{
            root: classes.tabs,
            indicator: classes.indicator,
            flexContainer: classes.tabsContainer,
            scrollButtonsDesktop: classes.scrollButtonsDesktop,
          }}
        >
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
            }}
            label="Inversión mensual"
            {...a11yProps(0)}
            icon={
              <img
                src={value === 0 ? iconBlue : iconGray}
                alt="icon"
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          ></Tab>
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
            }}
            label="Inversión anual"
            {...a11yProps(1)}
            name="politicas"
            icon={
              <img
                src={value === 0 ? iconGray : iconBlue}
                alt="icon"
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
        </Tabs>
      </AppBar>
      <TabInversion className={classes.panel} value={value} index={0}>
        <MembershipsCards
          platinum={{
            price: '$2,999.00',
            priceDisc: '',
            detail: 'Plan por 6 meses',
          }}
        />
      </TabInversion>
      <TabInversion value={value} index={1}>
        <MembershipsCards
          platinum={{
            price: '$14,396.00',
            priceDisc: '$17,994.00',
            detail: '20% de descuento',
          }}
        />
      </TabInversion>
    </div>
  );
}
